import { BehaviorSubject } from 'rxjs';
import { map, tap, switchMap } from 'rxjs/operators';
import apiService from 'v2/services/api';

import type { IComment, ITicket } from 'v2/interfaces/help';
import type { ApiService } from 'v2/services/api';

import type { Observable } from 'rxjs';

class HelpService {
  private loadingTickets$ = new BehaviorSubject(true);
  private loadingTicket$ = new BehaviorSubject(true);
  private tickets$ = new BehaviorSubject<ITicket[]>(null);
  private ticket$ = new BehaviorSubject<ITicket>(null);

  constructor(private apiService: ApiService) {}

  public loadTickets(): Observable<ITicket[]> {
    this.loadingTickets$.next(true);
    return this.apiService.get('/support/tickets').pipe(
      map((response) => response.data),
      tap((data) => {
        this.tickets$.next(data);
        this.loadingTickets$.next(false);
      })
    );
  }

  public showTicket(ticketId: number): Observable<ITicket> {
    this.loadingTicket$.next(true);
    return this.apiService.get(`/support/tickets/${ticketId}`).pipe(
      map((response) => response.data),
      tap((data) => {
        this.ticket$.next(data);
        this.loadingTicket$.next(false);
      })
    );
  }

  public sendComment(ticketId: number, comment: string): Observable<Pick<IComment, 'id'>> {
    return this.apiService.post(`/support/tickets/${ticketId}`, { comment }).pipe(switchMap(() => this.showTicket(ticketId)));
  }

  public newTicket(title: string, description: string): Observable<ITicket> {
    return this.apiService.post('/support/tickets', { title, description }).pipe(
      map((response) => response.data),
      tap((data) => this.tickets$.next([data, ...this.tickets$.value]))
    );
  }

  public getTicket(): Observable<ITicket> {
    return this.ticket$;
  }

  public getTickets(): Observable<ITicket[]> {
    return this.tickets$;
  }

  public getLoadingTickets(): Observable<boolean> {
    return this.loadingTickets$;
  }

  public getLoadingTicket(): Observable<boolean> {
    return this.loadingTicket$;
  }
}

const helpService = new HelpService(apiService);
export default helpService;
